function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
export default (function (_ref) {
  var _p, _choiceDescr;
  var colors = _ref.colors,
    mediaQueries = _ref.mediaQueries;
  return {
    title: _defineProperty({
      margin: '20px 15px'
    }, mediaQueries.breakpointLarge, {
      margin: '15px 0 30px'
    }),
    choice: _defineProperty({
      alignItems: 'center',
      background: colors.background,
      borderTop: '1px solid #D2D4D8',
      display: 'flex',
      float: 'left',
      justifContent: 'center',
      padding: '25px 10px 15px',
      textAlign: 'left',
      transition: 'all 0.5s ease',
      width: '100%',
      '&:hover': _defineProperty({
        borderRadius: '0',
        boxShadow: 'none',
        cursor: 'pointer',
        transition: 'all 0.4s ease'
      }, mediaQueries.breakpointLarge, {
        borderRadius: '8px',
        boxShadow: '0 2px 19px 0 rgba(0,0,0,0.11)'
      }),
      '&:last-child': _defineProperty({
        borderBottom: '1px solid #D2D4D8'
      }, mediaQueries.breakpointLarge, {
        border: 'none'
      })
    }, mediaQueries.breakpointLarge, {
      border: '0',
      display: 'block',
      padding: '43px 30px',
      textAlign: 'center',
      marginLeft: '1%',
      marginRight: '1%',
      width: '48%'
    }),
    icon: _defineProperty({
      float: 'left',
      margin: 'auto',
      padding: '0 20px',
      width: '90px',
      '& svg': _defineProperty({
        maxHeight: '55px',
        maxWidth: '50px',
        fill: colors.titleIconsColor
      }, mediaQueries.breakpointLarge, {
        maxHeight: '73px',
        maxWidth: '100%'
      })
    }, mediaQueries.breakpointLarge, {
      float: 'none',
      width: 'auto'
    }),
    choiceDescr: (_choiceDescr = {
      float: 'left',
      margin: 'auto',
      paddingRight: '20px',
      width: '100%'
    }, _defineProperty(_choiceDescr, mediaQueries.breakpointLarge, {
      float: 'none',
      width: '100%',
      padding: '0'
    }), _defineProperty(_choiceDescr, '& p', (_p = {
      color: colors.lightGrayDescription,
      padding: '0',
      minHeight: '60px'
    }, _defineProperty(_p, mediaQueries.breakpointLarge, {
      fontSize: '13px',
      marginBottom: '25px'
    }), _defineProperty(_p, mediaQueries.breakpointTablet, {
      minHeight: 'initial'
    }), _p)), _defineProperty(_choiceDescr, '& button', _defineProperty({
      display: 'none'
    }, mediaQueries.breakpointLarge, {
      display: 'block'
    })), _choiceDescr),
    subtitle: _defineProperty({
      color: colors.darkGray,
      fontSize: '16pt',
      lineHeight: '30px',
      margin: 'inherit',
      textTransform: 'uppercase',
      '& p': {}
    }, mediaQueries.breakpointLarge, {
      fontSize: '16px',
      display: 'block',
      margin: '30px 0 0'
    }),
    arrow: {
      float: 'right',
      fill: colors.arrowIconColor,
      '& svg': {
        width: '14px'
      }
    }
  };
});